import '../assets/css/bootstrap-iso.min.css'
import '../assets/css/style.css'

import Navbar from './Components/Navbar'
import Topbar from './Components/Topbar'
import ProductList from './Components/ProductList'
import Footer from './Components/Footer'
import { useGetShopQuery } from '../Redux/Apis/shopApi'
import { Link } from 'react-router-dom'

export default function ShopApp(){
    const { data } = useGetShopQuery()
    return(
        <>
        {data && data.status === "ACTIVE" ? <div className='bootstrap-iso'>
            <Navbar />
            <Topbar data={data}/>
            <ProductList data={data.Products}/>
            <Footer/>
        </div> :
        <div className='bootstrap-iso text-center '>
            <div className="alert alert-warning my-5" role="alert">
                <p>
                    فروشگاه غیر فعال است    
                </p>
                <Link to="/" className='btn btn-primary'>بازگشت به سایت</Link> 
            </div>
        </div>
        }
        </>
    )
}